import React from "react"
import { connect } from "react-redux"
import { getPlanText } from "../../../redux/selectors/basket-selectors"
import ReactHtmlParser from "react-html-parser"
import "./plan.scss"
import { PropTypes } from "prop-types"

const Plan = ({ planText }) => (
  <div className="planMemo">
    <h3>Plan</h3>
    <p>{ReactHtmlParser(planText)}</p>
  </div>
)

const mapStateToProps = state => ({
  planText: getPlanText(state)
})

Plan.propTypes = {
  planText: PropTypes.string
}

export default connect(mapStateToProps)(Plan)
